import styled, { css } from 'styled-components';

import { IconButton } from '@xing-com/button';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Link } from '@xing-com/link';
import { Tag } from '@xing-com/tag';
import {
  spaceXS,
  spaceL,
  spaceXL,
  xdlColorTextOnLight,
  xdlColorHoverSecondary,
  spaceM,
  space3XL,
  spaceS,
} from '@xing-com/tokens';

export const StyledKeywords = styled.div<{
  $keywordsPrepared: boolean;
  $isTouchDevice: boolean | undefined;
}>`
  display: flex;
  position: relative;
  white-space: nowrap;
  width: 100%;
  padding: 0 calc(${spaceL} - ${spaceXS}) ${spaceXL};
  overflow-x: hidden;
  scrollbar-width: none;
  ${({ $keywordsPrepared }) => !$keywordsPrepared && 'visibility: hidden;'}
  ${({ $isTouchDevice }) => $isTouchDevice && 'overflow-x: auto;'}

  @media ${mediaConfined} {
    flex-wrap: nowrap;
    padding: 0 calc(${spaceM} - ${spaceXS}) ${space3XL};
  }
`;

export const StyledLink = styled(Link)<{
  $isDragging: boolean;
}>`
  display: inline-flex;
  margin: ${spaceXS};
  color: ${xdlColorTextOnLight};
  ${({ $isDragging }) => $isDragging && 'pointer-events: none;'}

  &:hover {
    text-decoration: none;
  }
`;

export const StyledTag = styled(Tag)`
  user-select: none;

  &:hover {
    background-color: ${xdlColorHoverSecondary};
    border-color: ${xdlColorHoverSecondary};
    color: ${xdlColorTextOnLight};
  }
`;

export const AiTag = styled(Tag)<{ $isNew?: boolean }>`
  width: fit-content;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${xdlColorHoverSecondary};
  }

  ${({ $isNew }) =>
    $isNew &&
    css`
      && span {
        display: flex;
        gap: ${spaceS};
      }
    `}
`;

export const AiTagContent = styled.span`
  display: flex;
  align-items: center;
  gap: ${spaceXS};
`;

export const StyledLeftButton = styled(IconButton)`
  position: absolute;
  left: ${spaceXS};
  margin-top: -${space3XL};
  z-index: 2;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const StyledRightButton = styled(IconButton)`
  position: absolute;
  right: ${spaceXS};
  margin-top: -${space3XL};
  z-index: 2;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;
